var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 217,
    viewBox: "0 0 394 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_7746)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 393.33,
    height: 216.646,
    fill: "url(#paint0_radial_4130_7746)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4130_7746)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4130_7746)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 195.692,
    cy: 107.88,
    r: 49.5191,
    fill: "url(#paint1_linear_4130_7746)",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 195.692,
    cy: 107.88,
    r: 54.8247,
    stroke: "white",
    strokeWidth: 10.6112
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4130_7746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.856 104.796V111.87M207.076 104.796V111.87M178.783 101.614L178.783 115.053C178.783 117.033 178.783 118.023 179.169 118.78C179.508 119.445 180.049 119.986 180.714 120.326C181.471 120.711 182.461 120.711 184.442 120.711L208.49 120.711C210.471 120.711 211.461 120.711 212.218 120.326C212.883 119.986 213.424 119.445 213.763 118.78C214.149 118.024 214.149 117.033 214.149 115.053V101.614C214.149 99.6329 214.149 98.6426 213.763 97.8861C213.424 97.2206 212.883 96.6796 212.218 96.3405C211.461 95.9551 210.471 95.9551 208.49 95.9551L184.442 95.9551C182.461 95.9551 181.471 95.9551 180.714 96.3405C180.049 96.6796 179.508 97.2206 179.169 97.8861C178.783 98.6426 178.783 99.6329 178.783 101.614ZM200.887 108.333C200.887 110.775 198.907 112.754 196.466 112.754C194.025 112.754 192.045 110.775 192.045 108.333C192.045 105.892 194.025 103.912 196.466 103.912C198.907 103.912 200.887 105.892 200.887 108.333Z",
    stroke: "url(#paint2_linear_4130_7746)",
    strokeWidth: 3.53708,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 25.9123,
    y: -14.5408,
    width: 338.675,
    height: 291.316
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(8.84px)",
      clipPath: "url(#bgblur_1_4130_7746_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4130_7746)",
    "data-figma-bg-blur-radius": 17.6854
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0177 5.20566C90.2551 2.44302 85.7622 2.4324 83.1314 5.32083C64.5849 25.6834 51.9023 50.751 46.5116 77.8519C40.6601 107.27 43.6633 137.762 55.1415 165.472C66.6197 193.183 86.0573 216.868 110.996 233.532C135.935 250.196 165.256 259.09 195.25 259.09C225.244 259.09 254.564 250.196 279.503 233.532C304.442 216.868 323.88 193.183 335.358 165.472C346.836 137.762 349.84 107.269 343.988 77.8518C338.597 50.7509 325.915 25.6834 307.368 5.32079C304.737 2.43236 300.244 2.44298 297.482 5.20562L257.343 45.3443C254.581 48.1069 254.608 52.5676 257.118 55.5614C265.81 65.9275 271.784 78.3441 274.438 91.6863C277.553 107.348 275.954 123.582 269.843 138.335C263.732 153.088 253.384 165.698 240.106 174.57C226.829 183.442 211.219 188.177 195.25 188.177C179.281 188.177 163.671 183.442 150.393 174.57C137.116 165.698 126.767 153.088 120.656 138.335C114.546 123.582 112.947 107.348 116.062 91.6863C118.716 78.3441 124.689 65.9276 133.382 55.5614C135.892 52.5676 135.919 48.1069 133.156 45.3443L93.0177 5.20566Z",
    fill: "white",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4130_7746",
    x: 135.561,
    y: 47.75,
    width: 120.261,
    height: 120.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.53708
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.595686 0 0 0 0 0.0121568 0 0 0 0 0.0121568 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7746"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4130_7746",
    x: 135.561,
    y: 47.75,
    width: 120.261,
    height: 120.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.478431 0 0 0 0 0.00784314 0 0 0 0 0.00784314 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7746"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4130_7746",
    x: 177.015,
    y: 94.1875,
    width: 38.9028,
    height: 29.3541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.06112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.530561
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7746"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4130_7746",
    x: 25.9123,
    y: -14.5408,
    width: 338.675,
    height: 291.316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.53708
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76854
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4130_7746"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4130_7746",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_4130_7746_clip_path",
    transform: "translate(-25.9123 14.5408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.0177 5.20566C90.2551 2.44302 85.7622 2.4324 83.1314 5.32083C64.5849 25.6834 51.9023 50.751 46.5116 77.8519C40.6601 107.27 43.6633 137.762 55.1415 165.472C66.6197 193.183 86.0573 216.868 110.996 233.532C135.935 250.196 165.256 259.09 195.25 259.09C225.244 259.09 254.564 250.196 279.503 233.532C304.442 216.868 323.88 193.183 335.358 165.472C346.836 137.762 349.84 107.269 343.988 77.8518C338.597 50.7509 325.915 25.6834 307.368 5.32079C304.737 2.43236 300.244 2.44298 297.482 5.20562L257.343 45.3443C254.581 48.1069 254.608 52.5676 257.118 55.5614C265.81 65.9275 271.784 78.3441 274.438 91.6863C277.553 107.348 275.954 123.582 269.843 138.335C263.732 153.088 253.384 165.698 240.106 174.57C226.829 183.442 211.219 188.177 195.25 188.177C179.281 188.177 163.671 183.442 150.393 174.57C137.116 165.698 126.767 153.088 120.656 138.335C114.546 123.582 112.947 107.348 116.062 91.6863C118.716 78.3441 124.689 65.9276 133.382 55.5614C135.892 52.5676 135.919 48.1069 133.156 45.3443L93.0177 5.20566Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4130_7746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.665 108.323) rotate(90) scale(129.545 235.195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4130_7746",
    x1: 195.692,
    y1: 58.3613,
    x2: 195.692,
    y2: 157.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B71212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A0202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4130_7746",
    x1: 178.046,
    y1: 102.66,
    x2: 201.225,
    y2: 136.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B71212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#600505"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_7746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393.33,
    height: 216.646,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryOther);
export default __webpack_public_path__ + "static/media/library-other.c9db47876d530a5b9cdbeb9707818117.svg";
export { ForwardRef as ReactComponent };